require('./_set-species')('Array');


//////////////////
// WEBPACK FOOTER
// ../wheelhouse-core/~/core-js/modules/es6.array.species.js
// module id = 287
// module chunks = 0